import React from 'react';
const links = [{
  href: '#library',
  label: 'Your six books'
}, {
  href: '#books',
  label: 'Bonus book library'
}, {
  href: '#bonus',
  label: 'Activity packs'
}, {
  href: '#ages',
  label: 'Explore by age'
}, {
  href: '#getting-started',
  label: 'Getting started'
}];
export function SectionNav() {
  return <nav aria-label="Jump to a section" className="pt-12 sm:pt-16" data-id="element-242" data-mp="o4pprtflntkd">
      <ul className="flex flex-wrap gap-2" data-id="element-243" data-mp="1ktoz7brx71e5">
        {links.map(link => <li key={link.href} data-id="element-244" data-mp="1kvrmho1ougf6">
            <a href={link.href} className="inline-flex rounded-full border border-navy/15 bg-white px-4 py-2 font-sans text-[13px] font-medium text-navy/75 transition-colors duration-150 ease-out hover:border-navy/40 hover:text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-paper" data-id="element-245" data-mp="1grtnreg9z7mn">
              {link.label}
            </a>
          </li>)}
      </ul>
    </nav>;
}